import React from 'react';
import PropTypes from 'prop-types';
import { InputTypes, InputElementTypes } from './InputTypes';

const withTextInput = (WrappedComponent) => {
  if (!InputElementTypes.includes(WrappedComponent)) {
    return null;
  }

  class WrappedComponentWithTextInput extends React.PureComponent {
    render() {
      const { children, className, forwardedRef, id, inputClasses, label, ...rest } = this.props;
      return (
        <div>
          <div className={`ds-text-input ${className}`}>
            {label &&
              <label htmlFor={id} >
                {label}
              </label>
            }
            <WrappedComponent
              {...rest}
              className={inputClasses}
              id={id}
              name={id}
              ref={forwardedRef}
            />
            {children}
          </div>
        </div>
      );
    }
}

  WrappedComponentWithTextInput.defaultProps = {
    autoComplete: 'off',
    children: null,
    className: '',
    forwardedRef: null,
    inputClasses: '',
    label: '',
    placeholder: '',
    type: 'text',
    value: undefined,
  };

  WrappedComponentWithTextInput.propTypes = {
    autoComplete: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    inputClasses: PropTypes.string,
    forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.oneOf(InputTypes),
    value: PropTypes.string,
  };
  return WrappedComponentWithTextInput;
};

export default withTextInput;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/TextInputs/withTextInput.jsx